import * as React from "react"
import { ChevronDownIcon, KeyboardIcon } from "./icons"

interface IProps {
  selector: string | null
  onCancel: () => void
}

const ElementPickerBar = ({ selector, onCancel }: IProps) => (
  <div className="bizzey-tb-bar bizzey-tb-picker-bar">
    <button type="button" className="bizzey-tb-icon-button" title="Keyboard shortcuts" aria-label="Keyboard shortcuts">
      <KeyboardIcon />
    </button>

    <button type="button" className="bizzey-tb-picker-bar__hide">
      Hide
      <ChevronDownIcon />
    </button>

    <span className="bizzey-tb-picker-bar__divider" />

    <code className="bizzey-tb-picker-bar__selector">{selector || "Hover an element to select it"}</code>

    <button type="button" className="bizzey-tb-picker-bar__cancel" onClick={onCancel}>
      Cancel
    </button>
  </div>
)

export default ElementPickerBar
